import { Component, OnInit } from '@angular/core';
import { AppComponent } from './app.component';
import { TovpilCookieService } from 'src/app/utils/tovpil-cookie.service';
import { CookieTovpil } from 'src/app/shared/models/CookieTovpil';
import { UserPreferencesService } from 'src/app/utils/user-preferences.service';
import { TovpilLanguageService } from './utils/tovpil-language.service';

@Component({
    selector: 'app-menu',
    template: `
        <ul class="layout-menu">
            <li app-menuitem *ngFor="let item of model; let i = index;" [item]="item" [index]="i" [root]="true"></li>
        </ul>
    `,
    providers: [TovpilCookieService, TovpilLanguageService]
})
export class AppMenuComponent implements OnInit {

    /** USER PREFERENCES */
    userPreferences: CookieTovpil = {};
    userToken: string;



    model: any[];

    constructor(public app: AppComponent,
        private cookieService: TovpilCookieService,
        private userPreferencesService: UserPreferencesService,
        private translationService: TovpilLanguageService
    ) {
        this.initConfigs();
    }

    async ngOnInit() {
        let translations = await this.getTranslatedLabels();
        this.model = [
            /*{
                label: 'Dashboard', icon: 'pi pi-fw pi-home',
                items: [
                    { label: 'Dashboard Sales', icon: 'pi pi-fw pi-home', routerLink: ['/'], badge: '4', badgeClass: 'p-badge-info' },
                    {
                        label: 'Dashboard Analytics', icon: 'pi pi-fw pi-home',
                        routerLink: ['/favorites/dashboardanalytics'], badge: '2', badgeClass: 'p-badge-success'
                    }
                ]
            },
            {
                label: 'Infor/Segui', icon: 'pi pi-fw pi-book', routerLink: ['/pages'], badgeStyleClass: 'teal-badge',
                items: [
                    {
                        label: 'Semestre Secretario', icon: 'pi pi-fw pi-calendar', routerLink: ['/pages'],
                        items: [
                            { label: 'Matriz Estadísticos', routerLink: ['/pages'] },
                            { label: 'Indicadores refundación', routerLink: ['/pages'] },
                        ]
                    },
                    {
                        label: 'Fs', icon: 'pi pi-fw pi-book', routerLink: ['/pages'],
                        items: [
                            { label: 'FI', routerLink: ['/pages'] },
                            { label: 'FII', routerLink: ['/pages'] },
                            { label: 'FIII', routerLink: ['/pages'] },
                            { label: 'FV', routerLink: ['/pages'] },
                            { label: 'FVI', routerLink: ['/pages'] },
                            { label: 'FVII', routerLink: ['/pages'] },
                        ]
                    },
                    {
                        label: 'Guias', icon: 'pi pi-fw pi-user', routerLink: ['/pages'],
                        items: [
                            { label: 'Bajas', routerLink: ['/pages'] },
                            { label: 'No acepta Entreg de Emails', routerLink: ['/pages'] },
                            { label: 'Status Guias(Resúmen)', routerLink: ['/pages'] },
                            { label: 'Guías enviados (Resúmen)', routerLink: ['/pages'] },
                            { label: 'Guías Details', routerLink: ['/pages'] }
                        ]
                    },
                    {
                        label: 'Futuro Guía', icon: 'pi pi-fw pi-user-plus', routerLink: ['/'],
                        items: [
                            { label: 'Seguimiento', routerLink: ['/pages'] },
                            { label: 'Resúmen', routerLink: ['/pages'] }
                        ]
                    },
                    {
                        label: 'Servicios', icon: 'pi pi-fw pi-briefcase', routerLink: ['/pages'],
                        items: [
                            { label: 'Pendiente Registro del Taller', routerLink: ['/pages'] },
                            { label: 'Pediente participantes', routerLink: ['/pages'] },
                            { label: 'Servicios Periodo', routerLink: ['/pages'] },
                            { label: 'Pendiente Finalizar periodo / Cerrar', routerLink: ['/pages'] },
                            { label: 'Servicios Jovenes Período', routerLink: ['/pages'] },
                            { label: 'Servicios Adolecentes Período', routerLink: ['/pages'] },
                            { label: 'Servicios Niños Período', routerLink: ['/pages'] },
                            { label: 'Etapas Período', routerLink: ['/pages'] },
                            { label: 'EPG Período / Cerrar', routerLink: ['/pages'] },
                            { label: 'Buscar', routerLink: ['/pages'] }
                        ]
                    },
                    {
                        label: 'Materiales', icon: 'pi pi-fw pi-table', routerLink: ['/pages'],
                        items: [
                            { label: 'Pendiente Ingrese inventario físico', routerLink: ['/pages'] },
                            { label: 'Control envios materiales', routerLink: ['/pages'] },
                            { label: 'Análisis de inventarios', routerLink: ['/pages'] },
                            { label: 'Remisión Rastreo', routerLink: ['/pages'] },
                            { label: 'Resumen de Compras a proveedores', routerLink: ['/pages'] }
                        ]
                    },
                    {
                        label: 'Tesorería', icon: 'pi pi-fw pi-dollar', routerLink: ['/'],
                        items: [
                            { label: 'Avance cargos/DIE', routerLink: ['/pages'] },
                            { label: 'Status Período DIE', routerLink: ['/pages'] },
                            { label: 'FII Moneda', routerLink: ['/pages'] }
                        ]
                    }
                ]
            },
            */
            {
                label: 'Santov', icon: 'pi pi-fw pi-desktop', routerLink: ['/pages'], badgeStyleClass: 'teal-badge',
                items: [
                    {
                        label: `${translations.lbl_reports} ${translations.lbl_and} ${translations.lbl_following_up}`, icon: 'pi pi-fw pi-dollar', routerLink: ['/pages'], badgeStyleClass: 'teal-badge',
                        items: [
                            {
                                label: `${translations.lbl_reports} Fs`, icon: 'pi pi-fw pi-globe', routerLink: ['/pages'],
                                items: [
                                    { label: 'FI', icon: 'pi pi-fw pi-briefcase', routerLink: ['sc/commons/lcSelector'], queryParams: { module: 'secretary', view: 'FISummary' } },
                                    { label: 'FV', icon: 'pi pi-fw pi-briefcase', routerLink: ['sc/commons/lcSelector'], queryParams: { module: 'treasurer', view: 'receivableLstH' } },
                                    { label: 'FVII', icon: 'pi pi-fw pi-briefcase', routerLink: ['sc/commons/lcSelector'], queryParams: {module: 'treasurer', view : 'FVIIEconReal'}},
                                ]
                            },
                            {
                                label: translations.lbl_guides, icon: 'pi pi-fw pi-user', routerLink: ['/pages'],
                                items: [
                                    { label: `${translations.lbl_status}  ${translations.lbl_guides} (${translations.lbl_summary})`, icon: 'pi pi-fw pi-list', routerLink: ['sc/reports/stsGuides'], queryParams: { token: this.userToken } },
                                    { label: `${translations.lbl_sent}  ${translations.lbl_guides} (${translations.lbl_summary})`, icon: 'pi pi-fw pi-list', routerLink: ['sc/reports/sentGuides'], queryParams: { token: this.userToken } },
                                    { label: `${translations.lbl_guides} ${translations.lbl_detail}`, icon: 'pi pi-fw pi-list', routerLink: ['sc/reports/guidesReport'], queryParams: { token: this.userToken } },
                                ]
                            },
                            {
                                label: translations.lbl_future_guide, icon: 'pi pi-fw pi-user', routerLink: ['/pages'],
                                items: [
                                    { label: `${translations.lbl_following_up} ${translations.lbl_future_guide}`, icon: 'pi pi-fw pi-user', routerLink: ['sc/secretary/futureGuiSch'], queryParams: { token: this.userToken } },
                                    { label: `${translations.lbl_future_guide} ${translations.lbl_summary}`, icon: 'pi pi-fw pi-user', routerLink: ['sc/reports/futureGuidesSum'], queryParams: { token: this.userToken } },
                                ]
                            },
                            {
                                label: translations.lbl_service, icon: 'pi pi-fw pi-user', routerLink: ['/pages'],
                                items: [
                                    { label: `${translations.lbl_pending} ${translations.lbl_participants}`, icon: 'pi pi-fw pi-user', routerLink: ['sc/commons/querysView'], queryParams: { qryId: '01' } },
                                    { label: `${translations.lbl_services} ${translations.lbl_period}`, icon: 'pi pi-fw pi-user', routerLink: ['sc/commons/querysView'], queryParams: { qryId: '02C' } },
                                    { label: `${translations.lbl_pending} ${translations.lbl_done}`, icon: 'pi pi-fw pi-user', routerLink: ['sc/commons/querysView'], queryParams: { qryId: 'PENDING_WRKS_CLOSE' } },
                                    { label: `${translations.lbl_services} ${translations.lbl_adults} ${translations.lbl_period}`, icon: 'pi pi-fw pi-user', routerLink: ['sc/reports/tracingWorkshops'], queryParams: { selSerTyp: '02', token: this.userToken } },
                                    { label: `${translations.lbl_services} ${translations.lbl_youngs} ${translations.lbl_period}`, icon: 'pi pi-fw pi-user', routerLink: ['sc/reports/tracingWorkshops'], queryParams: { selSerTyp: 'youngs', token: this.userToken } },
                                    { label: `${translations.lbl_services} ${translations.lbl_adolescents} ${translations.lbl_period}`, icon: 'pi pi-fw pi-user', routerLink: ['sc/reports/tracingWorkshops'], queryParams: { selSerTyp: 'youngTeens', token: this.userToken } },
                                    { label: `${translations.lbl_services} ${translations.lbl_children} ${translations.lbl_period}`, icon: 'pi pi-fw pi-user', routerLink: ['sc/reports/tracingWorkshops'], queryParams: { selSerTyp: 'children', token: this.userToken } },
                                    { label: `${translations.lbl_services} ${translations.lbl_marr_cours} ${translations.lbl_period}`, icon: 'pi pi-fw pi-user', routerLink: ['sc/reports/tracingWorkshops'], queryParams: { selSerTyp: '06', token: this.userToken } },
                                    { label: `${translations.lbl_stages} ${translations.lbl_period}`, icon: 'pi pi-fw pi-user', routerLink: ['sc/reports/tracingWorkshops'], queryParams: { selSerTyp: 'sfpg', token: this.userToken } },
                                    { label: `${translations.lbl_sch_for_prepar_guid} ${translations.lbl_period}`, icon: 'pi pi-fw pi-user', routerLink: ['sc/secretary/eppgList'], queryParams: { token: this.userToken } },
                                ]
                            },
                            {
                                label: translations.lbl_materials, icon: 'pi pi-fw pi-briefcase', routerLink: ['/pages'],
                                items: [
                                    { label: `${translations.lbl_pending} ${translations.lbl_entry_physical_inventory}`, icon: 'pi pi-fw pi-user', routerLink: ['sc/commons/querysView'], queryParams: { qryId: '10' } },
                                    { label: `${translations.lbl_summary} de Compras a Vendedores`, icon: 'pi pi-fw pi-dollar', routerLink: ['sc/reports/zoneProductionOrders'], queryParams: { token: this.userToken } },
                                ]
                            },

                            { label: `MATNATREQ`, icon: 'pi pi-fw pi-user', routerLink: ['sc/materials/matNatReqLst'] },
                            { label: `GUIDESITEMSUMMARY`, icon: 'pi pi-fw pi-user', routerLink: ['sc/treasurer/guidesItemSummary'] },
                        ]
                    },
                    {
                        label: translations.lbl_secretary, icon: 'pi pi-fw pi-dollar', routerLink: ['/pages'],
                        items: [
                            { label: `WrkPla) ${translations.lbl_services}`, icon: 'pi pi-fw pi-briefcase', routerLink: ['/sc/commons/lcSelector'], queryParams: { module: 'secretary', view: 'wrkshopMngComponent', forLevelId: 'L' } },
                            { label: `PICSer) ${translations.lbl_prayer_life_circle}`, icon: 'pi pi-fw pi-users', routerLink: ['/pages'] },
                            { label: `CoSerG) ${translations.lbl_communion_service_group}`, icon: 'pi pi-fw pi-users', routerLink: ['/pages'] },
                            { label: `CirGui) ${translations.lbl_circle_guides}`, icon: 'pi pi-fw pi-users', routerLink: ['/pages'] },
                            { label: `SFPG) ${translations.lbl_school_prep_guides}`, icon: 'pi pi-fw pi-globe', routerLink: ['sc/commons/lcSelector'], queryParams: { module: 'catalogs', view: 'schoolfpg', forLevelId: 'L' } },
                            { label: `AttRec) ${translations.lbl_event_attendance_registration}`, icon: 'pi pi-fw pi-user-plus', routerLink: ['/pages'] },
                            { label: `FVI) ${translations.lbl_inventory_other_assets}`, icon: 'pi pi-fw pi-book', routerLink: ['/pages'] },
                            { label: 'Test WS', icon: 'pi pi-fw pi-globe', routerLink: ['/pages'] },

                        ]
                    },
                    {
                        label: translations.lbl_treasurer, icon: 'pi pi-fw pi-dollar', routerLink: ['/pages'],
                        items: [
                            { label: `CXC1) ${translations.lbl_guides}`, icon: 'pi pi-fw pi-users', routerLink: ['/pages'] },
                            { label: `CXC2) ${translations.lbl_account_receiva_payable}`, icon: 'pi pi-fw pi-money-bill', routerLink: ['sc/commons/lcSelector'], queryParams: { module: 'treasurer', view: 'receivableLstH', forLevelId: 'L' } },
                            { label: `CXC3) ${translations.lbl_material_payment_registry_Loc}`, icon: 'pi pi-fw pi-book', routerLink: ['sc/commons/lcSelector'], queryParams: { module: 'treasurer', view: 'locMatCtlLst', forLevelId: 'L' } },
                            { label: `CXC4) FII ${translations.lbl_die}`, icon: 'pi pi-fw pi-shield', routerLink: ['sc/commons/lcSelector'], queryParams: { module: 'treasurer', view: 'fiiList' } },
                            { label: `CXC5) ${translations.lbl_FI_offer_registry_Loc}`, icon: 'pi pi-fw pi-save', routerLink: ['sc/commons/lcSelector'], queryParams: { module: 'treasurer', view: 'jrnHGuideReferInc', forLevelId: 'L' } },
                            { label: `${translations.lbl_international_price_list}`, icon: 'pi pi-fw pi-globe', routerLink: ['/sc/treasurer/priceListInt'] },
                            { label: `CONFIRMA_AUDIOS`, icon: "pi pi-fw pi-globe", routerLink: ['/sc/treasurer/confirmAudioReprod'] },
                            { label: `Autorización Audios`, icon: "pi pi-fw pi-globe", routerLink: ['sc/treasurer/grantMediaExterns'] },
                        
                        ]
                    },
                    {
                        label: translations.lbl_materials, icon: 'pi pi-fw pi-check-square', routerLink: ['/pages'], badgeStyleClass: 'teal-badge',
                        items: [
                            { label: `Contenido Multimedia Tovpil`, icon: 'pi pi-fw pi-video', routerLink: ['sc/materials/videoPlayerLst'] },
                            { label: 'Alta Videos', icon: 'pi pi-fw pi-sync', routerLink: ['sc/materials/videoUpload'] },
                            {
                                label: `${translations.lbl_orders_request}`, icon: 'pi pi-fw pi-check-square', routerLink: ['/pages'], badgeStyleClass: 'teal-badge',
                                items: [
                                    { label: `${translations.lbl_suppliers_requests}`, icon: 'pi pi-fw pi-users', routerLink: ['/sc/materials/purchOrdSupLst'] },
                                    { label: `${translations.lbl_orders_request}`, icon: 'pi pi-fw pi-money-bill', routerLink: ['/pages'] },
                                    { label: `TRF) ${translations.lbl_transfers_amoung_stores}`, icon: 'pi pi-fw pi-book', routerLink: ['sc/treasurer/locMatCtlLst'] },
                                    { label: `${translations.lbl_item_summary}`, icon: 'pi pi-fw pi-shield', routerLink: ['sc/commons/lcSelector'] },
                                    { label: `${translations.lbl_item_summary} Hdr`, icon: 'pi pi-fw pi-save', routerLink: ['/pages'] }
                                ]
                            },
                            {
                                label: translations.lbl_inventory, icon: 'pi pi-fw pi-check-square', routerLink: ['/pages'], badgeStyleClass: 'teal-badge',
                                items: [
                                    { label: `${translations.lbl_remission_search_history_costs}`, icon: 'pi pi-fw pi-users', routerLink: ['/pages'] },
                                    { label: `${translations.lbl_FIII_Inventory_Balance_E_S}`, icon: 'pi pi-fw pi-money-bill', routerLink: ['/pages'] },
                                    { label: `INV1) ${translations.lbl_registry_phisic_inventory_Loc}`, icon: 'pi pi-fw pi-book', routerLink: ['sc/treasurer/locMatCtlLst'] },
                                    { label: `INV2) ${translations.lbl_registryApprove_phisic_inv_Nac}`, icon: 'pi pi-fw pi-book', routerLink: ['sc/treasurer/locMatCtlLst'] },
                                    { label: `INV3) ${translations.lbl_registryApprove_phisic_inv_Zon}`, icon: 'pi pi-fw pi-book', routerLink: ['sc/treasurer/locMatCtlLst'] },
                                    { label: `INV4) ${translations.lbl_registryApprove_phisic_inv_Int}`, icon: 'pi pi-fw pi-book', routerLink: ['sc/treasurer/locMatCtlLst'] },
                                    { label: `INV5) ${translations.lbl_reg_invent_adjust_damaged_err}`, icon: 'pi pi-fw pi-book', routerLink: ['sc/treasurer/locMatCtlLst'] },
                                    { label: `INV6) ${translations.lbl_inventory_adjustments_approval}`, icon: 'pi pi-fw pi-shield', routerLink: ['sc/commons/lcSelector'] },
                                    { label: `${translations.lbl_item_summary} ${translations.lbl_coordination}`, icon: 'pi pi-fw pi-save', routerLink: ['/pages'] }
                                ]
                            }
                        ]

                    },
                    {
                        label: translations.lbl_special_processes, icon: 'pi pi-fw pi-bookmark', routerLink: ['/pages'], badgeStyleClass: 'teal-badge',
                        items: [
                            { label: translations.lbl_exchange_rate, icon: 'pi pi-fw pi-dollar', routerLink: ['/pages'] },
                            { label: 'Procesos temporales', icon: 'pi pi-fw pi-calendar', routerLink: ['/pages'] },

                        ]
                    },
                    {
                        label: translations.lbl_expenses_management, icon: 'pi pi-fw pi-wallet', routerLink: ['/pages'], badgeStyleClass: 'teal-badge',
                        items: [
                            { label: translations.lbl_expenses, icon: 'pi pi-fw pi-money-bill', routerLink: ['/pages'] },
                            { label: translations.lbl_expenses_by_period, icon: 'pi pi-fw pi-calendar', routerLink: ['/pages'] },
                            { label: translations.lbl_income_expense_concepts, icon: 'pi pi-fw pi-table', routerLink: ['/pages'] },

                        ]
                    },
                    {
                        label: translations.lbl_catalogs_management, icon: 'pi pi-fw pi-list', routerLink: ['/uikit'],
                        items: [
                            { label: translations.lbl_items_management_Int, icon: 'pi pi-fw pi-id-card', routerLink: ['/notfound'] },
                            { label: `ArtZon) ${translations.lbl_items_zone}`, icon: 'pi pi-fw pi-check-square', routerLink: ['/notfound'] },
                            { label: `CtlCoo) ${translations.lbl_coordination_catalog}`, icon: 'pi pi-fw pi-clone', routerLink: ['/sc/catalogs/coordinationCatalog'] },
                            { label: `CtlSup) Proveedores autorizados', icon: 'pi pi-fw pi-mobile`, routerLink: ['/notfound'], class: 'rotated-icon' },
                            { label: `CtlSta) ${translations.lbl_citys_states}`, icon: 'pi pi-fw pi-table', routerLink: ['/notfound'] },
                            { label: `CtlGui) ${translations.lbl_guides}`, icon: 'pi pi-fw pi-list', routerLink: ['/notfound'] },
                            { label: `CtlChr) ${translations.lbl_churchs_chapels_parish}`, icon: 'pi pi-fw pi-share-alt', routerLink: ['/sc/catalogs/churchList'] },
                            { label: `CtlUsr) ${translations.lbl_users}`, icon: 'pi pi-fw pi-tablet', routerLink: ['/sc/catalogs/userslst'] },
                            { label: `CtlLoc) ${translations.lbl_local_coordination}`, icon: 'pi pi-fw pi-clone', routerLink: ['/notfound'] },
                            { label: `IntTea) ${translations.lbl_international_team}`, icon: 'pi pi-fw pi-clone', routerLink: ['/notfound'] },
                            { label: `CtlSeT) ${translations.lbl_service} ${translations.lbl_type}`, icon: 'pi pi-fw pi-clone', routerLink: ['/notfound'] },
                            { label: `CtlCoc) ${translations.lbl_cost_center}`, icon: 'pi pi-fw pi-clone', routerLink: ['/notfound'] },
                            { label: `${translations.lbl_concept} ${translations.lbl_die}`, icon: 'pi pi-fw pi-clone', routerLink: ['/sc/catalogs/fIIConcepts'], queryParams: { token: '62910b3fd1add548f3d02ca4' } },
                            { label: 'Carga Guias Externos Brasil', icon: 'pi pi-fw pi-clone', routerLink: ['/notfound'] },
                            { label: 'Carga Guias Externos EU', icon: 'pi pi-fw pi-clone', routerLink: ['/notfound'] },
                            { label: 'Coordinación Zonal', icon: 'pi pi-fw pi-circle-off', routerLink: ['sc/catalogs/coordZon'] },
                            { label: 'Coordinación Nacional', icon: 'pi pi-fw pi-circle-off', routerLink: ['sc/catalogs/coordNat'] },
                            { label: 'Coordinación Local', icon: 'pi pi-fw pi-circle-off', routerLink: ['sc/catalogs/coordLocal'] },


                        ]
                    },
                    {
                        label: translations.lbl_downloads, icon: 'pi pi-fw pi-compass', routerLink: ['utilities'],
                        items: [
                            { label: `(dwdAv) ${translations.lbl_play_audio} (MP3, MP4, PDF)`, icon: 'pi pi-fw pi-align-center', routerLink: ['sc/santov/shop'], queryParams: { token: this.userToken, device: '4', dnwGroup: 'items' } },
                            { label: `(dwdMT) ${translations.lbl_manuals_tutorials}`, icon: 'pi pi-fw pi-align-center', routerLink: ['sc/commons/guideLinesAssist'], queryParams: { token: this.userToken } },
                            { label: `(secFMT) ${translations.lbl_secretary_formats}`, icon: 'pi pi-fw pi-th-large', routerLink: ['/notfound'] },
                            { label: `(treaFMT) ${translations.lbl_treasurer_formats}`, icon: 'pi pi-fw pi-arrow-right', routerLink: ['/notfound'] },
                            { label: `(qrySer) ${translations.lbl_searching_services}`, icon: 'pi pi-fw pi-arrow-right', routerLink: ['/notfound'] }
                        ]
                    },
                    {
                        label: 'Administración', icon: 'pi pi-fw pi-dollar', routerLink: ['/pages'], badgeStyleClass: 'teal-badge',
                        items: [
                            { label: 'Administración Tasas de Cambio', icon: 'pi pi-fw pi-globe', routerLink: ['sc/commons/storeCurrencyAdm'] }
                        ]
                    },
                    {
                        label: 'Commons', icon: 'pi pi-fw pi-dollar', routerLink: ['/pages'], badgeStyleClass: 'teal-badge',
                        items: [
                            {
                                label: 'Commons', icon: 'pi pi-fw pi-dollar', routerLink: ['/pages'], badgeStyleClass: 'teal-badge',
                                items: [
                                    { label: 'Administración Tasas de Cambio', icon: 'pi pi-fw pi-globe', routerLink: ['sc/commons/storeCurrencyAdm'] },
                                    { label: 'Admministración Propiedades', icon: 'pi pi-fw pi-globe', routerLink: ['sc/commons/crudPropertiesDocument'] },
                                    { label: 'Admministración Guías Externos', icon: 'pi pi-fw pi-globe', routerLink: ['sc/commons/crudExternGuidesDocument'] },
                                ]
                            }
                        ]
                    }
                    /*
                    {
                        label: 'Responsivo', icon: 'pi pi-fw pi-dollar', routerLink: ['/pages'], badgeStyleClass: 'teal-badge',
                        items: [
                            {
                                label: 'CX2 Precios', icon: 'pi pi-fw pi-dollar', routerLink: ['/pages'], badgeStyleClass: 'teal-badge',
                                items: [
                                    { label: 'Lista Ciudades', icon: 'pi pi-fw pi-globe', routerLink: ['sc/treasurer/priceCountry'] },
                                    { label: 'Lista Precios ', icon: 'pi pi-fw pi-globe', routerLink: ['sc/treasurer/priceList'] }, //PROBLEM
                                    { label: 'Lista Precios Internacional', icon: 'pi pi-fw pi-globe', routerLink: ['sc/treasurer/priceListInt'] },
                                    { label: 'Lista Precios Zonal / Nacional', icon: 'pi pi-fw pi-globe', routerLink: ['sc/treasurer/priceListZon'] },
                                ]
                            },

                            {
                                label: 'CX3 Cargos por material', icon: 'pi pi-fw pi-dollar', routerLink: ['/pages'], badgeStyleClass: 'teal-badge',
                                items: [
                                    { label: 'CX3) REGISTRO CARGOS POR MATERIAL (E/S LOC)', icon: 'pi pi-fw pi-globe', routerLink: ['sc/treasurer/locMatCtlLst'] },
                                    { label: 'CX3) SOLICITUD CARGOS POR MATERIAL (E/S LOC)', icon: 'pi pi-fw pi-globe', routerLink: ['sc/treasurer/locMatCtlLstM'] },
                                    { label: 'CX3) SOLICITUD CARGOS POR MATERIAL E/S DTL', icon: 'pi pi-fw pi-globe', routerLink: ['sc/treasurer/locMatCtlDtl'] },
                                ]
                            },

                            {
                                label: 'CX4 FII DIE', icon: 'pi pi-fw pi-dollar', routerLink: ['/pages'], badgeStyleClass: 'teal-badge',
                                items: [
                                    // CX4
                                    { label: 'CX4) LC SELECTOR', icon: 'pi pi-fw pi-globe', routerLink: ['sc/commons/lcSelector'], queryParams: {module : 'treasurer', view : 'fiiList'} },
                                    { label: 'CX4) FII LIST', icon: 'pi pi-fw pi-globe', routerLink: ['sc/treasurer/fiiList'] },
                                    { label: 'CX4) FII RECEIVE PAYABLEMENT', icon: 'pi pi-fw pi-globe', routerLink: ['sc/treasurer/fiiReceive'] },
                                    { label: 'CX4) FII ECONOMIC REALITY', icon: 'pi pi-fw pi-globe', routerLink: ['sc/treasurer/fiiEconomicReality'] },
                                    { label: 'CX4) FII JOURNL ES LIST', icon: 'pi pi-fw pi-globe', routerLink: ['sc/treasurer/fiiJournlEsLst'] },
                                    { label: 'CX4) FII JOURNL', icon: 'pi pi-fw pi-globe', routerLink: ['sc/treasurer/fiiJournl'] },
                                    { label: 'CX4) FII JOURNL CONCEPT DETAIL', icon: 'pi pi-fw pi-globe', routerLink: ['sc/treasurer/fiiJournlConceptDetail'] },
                                    { label: 'CX4) FII RECEIVE PAYABLEMENT SUMMARY', icon: 'pi pi-fw pi-globe', routerLink: ['sc/treasurer/fiiReceiveSummary'] },
                                ]
                            },
                        ]
                    },*/
                ]
            },
            /*{
                label: 'Catálogos', icon: 'pi pi-fw pi-id-card', routerLink: ['/pages'], badgeStyleClass: 'teal-badge',
                items: [
                    { label: 'Email Template', icon: 'pi pi-fw pi-pencil', routerLink: ['catalogs/email'] },
                    { label: 'Talleres', icon: 'pi pi-fw pi-pencil', routerLink: ['guide/workshops'] },
                    { label: 'School', icon: 'pi pi-fw pi-pencil', routerLink: ['catalogs/schoolfpg'] },
                    { label: 'School Detail ', icon: 'pi pi-fw pi-plus', routerLink: ['catalogs/eppgs/schoolfpgDetail'] },

                    { label: 'Cambia Contraseña', icon: 'pi pi-fw pi-calendar-plus', routerLink: ['/catalogs/changePassword'] },
                    { label: 'Recupera Contraseña', icon: 'pi pi-fw pi-key', routerLink: ['/catalogs/recoverPassword'] },
                    { label: 'Crear Usuario', icon: 'pi pi-fw pi-user', routerLink: ['/catalogs/createUser'] },
                    { label: 'Registrar Capilla', icon: 'pi pi-fw pi-plus', routerLink: ['/catalogs/churchList'] },
                    { label: 'Catalogo Coordinacion', icon: 'pi pi-fw pi-plus', routerLink: ['/catalogs/coordinationCatalog'] },
                    { label: 'Catalogo Coordinacion Detalle', icon: 'pi pi-fw pi-plus', routerLink: ['catalogs/coordinationCatalogDtl'] },
                    { label: 'Usuarios List', icon: 'pi pi-fw pi-plus', routerLink: ['/catalogs/userslst'] },
                    { label: 'FII Concepts', icon: 'pi pi-fw pi-plus', routerLink: ['/catalogs/fIIConcepts'] },
                    { label: 'FII Concepts DTL  ', icon: 'pi pi-fw pi-plus', routerLink: ['/catalogs/fIIConceptsDtl'] },

                    { label: 'Lista de Precios Internacional', icon: 'pi pi-fw pi-globe', url: 'assets/pages/landing.html', target: '_blank' },
                    { label: 'Precio juegos', icon: 'pi pi-fw pi-sign-in', routerLink: ['/login'] },
                    { label: 'citys_states_', icon: 'pi pi-fw pi-dollar', routerLink: ['catalogs/countries'] },
                    { label: 'Guias', icon: 'pi pi-fw pi-question-circle', routerLink: ['/pages/help'] },
                    { label: 'Iglesias, Paqrroquias, Capillas ...', icon: 'pi pi-fw pi-times-circle', routerLink: ['/error'] },
                    { label: 'Usuarios', icon: 'pi pi-fw pi-exclamation-circle', routerLink: ['/santov/cat/users'] },
                    { label: 'Coordinación Local', icon: 'pi pi-fw pi-lock', routerLink: ['catalogs/coodLoc'] },
                    { label: 'Coordinación Nacional', icon: 'pi pi-fw pi-star', routerLink: ['catalogs/coodNat'] },
                    { label: 'Coordinación Zonal', icon: 'pi pi-fw pi-circle-off', routerLink: ['catalogs/coodZon'] },
                    { label: 'Centros costo', icon: 'pi pi-fw pi-circle-off', routerLink: ['/pages/empty'] },
                    { label: 'Equipo Internacional', icon: 'pi pi-fw pi-circle-off', routerLink: ['/pages/empty'] }

                ]
            },*/
            /*
            {
                label: 'Mis Datos', icon: 'pi pi-fw pi-user', routerLink: ['/pages'], badgeStyleClass: 'teal-badge',
                items: [
                    {label: 'Crud', icon: 'pi pi-fw pi-pencil', routerLink: ['/pages/crud']},
                    {label: 'Calendar', icon: 'pi pi-fw pi-calendar-plus', routerLink: ['/pages/calendar']},
                    {label: 'Landing', icon: 'pi pi-fw pi-globe', url: 'assets/pages/landing.html', target: '_blank'},
                    {label: 'Login', icon: 'pi pi-fw pi-sign-in', routerLink: ['/login']},
                    {label: 'Invoice', icon: 'pi pi-fw pi-dollar', routerLink: ['/pages/invoice']},
                    {label: 'Help', icon: 'pi pi-fw pi-question-circle', routerLink: ['/pages/help']},
                    {label: 'Error', icon: 'pi pi-fw pi-times-circle', routerLink: ['/error']},
                    {label: 'Not Found', icon: 'pi pi-fw pi-exclamation-circle', routerLink: ['/notfound']},
                    {label: 'Access Denied', icon: 'pi pi-fw pi-lock', routerLink: ['/access']},
                    {label: 'Wizard', icon: 'pi pi-fw pi-star', routerLink: ['/wizard']},
                    {label: 'Empty', icon: 'pi pi-fw pi-circle-off', routerLink: ['/pages/empty']}
                ]
            },*/
            /* 
            {
                label: 'UI Kit', icon: 'pi pi-fw pi-star', routerLink: ['/uikit'],
                items: [
                    {label: 'Input', icon: 'pi pi-fw pi-check-square', routerLink: ['/uikit/input'], badge: '6', badgeClass: 'p-badge-danger'},
                    {label: 'Float Label', icon: 'pi pi-fw pi-bookmark', routerLink: ['/uikit/floatlabel']},
                    {label: 'Invalid State', icon: 'pi pi-fw pi-exclamation-circle', routerLink: ['/uikit/invalidstate']},
                    {label: 'Button', icon: 'pi pi-fw pi-mobile', routerLink: ['/uikit/button'], class: 'rotated-icon'},
                    {label: 'Table', icon: 'pi pi-fw pi-table', routerLink: ['/uikit/table'], badge: '6', badgeClass: 'p-badge-help'},
                    {label: 'List', icon: 'pi pi-fw pi-list', routerLink: ['/uikit/list']},
                    {label: 'Tree', icon: 'pi pi-fw pi-share-alt', routerLink: ['/uikit/tree']},
                    {label: 'Panel', icon: 'pi pi-fw pi-tablet', routerLink: ['/uikit/panel']},
                    {label: 'Overlay', icon: 'pi pi-fw pi-clone', routerLink: ['/uikit/overlay']},
                    {label: 'Media', icon: 'pi pi-fw pi-image', routerLink: ['/uikit/media']},
                    {label: 'Menu', icon: 'pi pi-fw pi-bars', routerLink: ['/uikit/menu']},
                    {label: 'Message', icon: 'pi pi-fw pi-comment', routerLink: ['/uikit/message']},
                    {label: 'File', icon: 'pi pi-fw pi-file', routerLink: ['/uikit/file']},
                    {label: 'Chart', icon: 'pi pi-fw pi-chart-bar', routerLink: ['/uikit/charts']},
                    {label: 'Misc', icon: 'pi pi-fw pi-circle-off', routerLink: ['/uikit/misc']}
                ]
            }
            
            {
                label: 'Utilities', icon: 'pi pi-fw pi-compass', routerLink: ['utilities'],
                items: [
                    {label: 'Form Layout', icon: 'pi pi-fw pi-id-card', routerLink: ['/uikit/formlayout'], badge: '6', badgeClass: 'p-badge-warning'},
                    {label: 'Display', icon: 'pi pi-fw pi-desktop', routerLink: ['utilities/display']},
                    {label: 'Elevation', icon: 'pi pi-fw pi-external-link', routerLink: ['utilities/elevation']},
                    {label: 'FlexBox', icon: 'pi pi-fw pi-directions', routerLink: ['utilities/flexbox']},
                    {label: 'Icons', icon: 'pi pi-fw pi-search', routerLink: ['utilities/icons']},
                    {label: 'Text', icon: 'pi pi-fw pi-pencil', routerLink: ['utilities/text']},
                    {label: 'Widgets', icon: 'pi pi-fw pi-star-o', routerLink: ['utilities/widgets']},
                    {label: 'Grid System', icon: 'pi pi-fw pi-th-large', routerLink: ['utilities/grid']},
                    {label: 'Spacing', icon: 'pi pi-fw pi-arrow-right', routerLink: ['utilities/spacing']},
                    {label: 'Typography', icon: 'pi pi-fw pi-align-center', routerLink: ['utilities/typography']}
                ]
            }
            
            {
                label: 'Pages', icon: 'pi pi-fw pi-briefcase', routerLink: ['/pages'],
                items: [
                    {label: 'Crud', icon: 'pi pi-fw pi-pencil', routerLink: ['/pages/crud']},
                    {label: 'Calendar', icon: 'pi pi-fw pi-calendar-plus', routerLink: ['/pages/calendar']},
                    {label: 'Timeline', icon: 'pi pi-fw pi-calendar', routerLink: ['/pages/timeline']},
                    {
                        label: 'Landing', icon: 'pi pi-fw pi-globe', badge: '2', badgeClass: 'p-badge-warning',
                        items: [
                            {label: 'Static', icon: 'pi pi-fw pi-globe', url: 'assets/pages/landing.html', target: '_blank'},
                            {label: 'Component', icon: 'pi pi-fw pi-globe', routerLink: ['/landing']}
                        ]
                    },
                    {label: 'Login', icon: 'pi pi-fw pi-sign-in', routerLink: ['/login']},
                    {label: 'Invoice', icon: 'pi pi-fw pi-dollar', routerLink: ['/pages/invoice']},
                    {label: 'Help', icon: 'pi pi-fw pi-question-circle', routerLink: ['/pages/help']},
                    {label: 'Error', icon: 'pi pi-fw pi-times-circle', routerLink: ['/error']},
                    {label: 'Not Found', icon: 'pi pi-fw pi-exclamation-circle', routerLink: ['/notfound']},
                    {label: 'Access Denied', icon: 'pi pi-fw pi-lock', routerLink: ['/access']},
                    {label: 'Contact Us', icon: 'pi pi-fw pi-pencil', routerLink: ['/contactus']},
                    {label: 'Empty', icon: 'pi pi-fw pi-circle-off', routerLink: ['/pages/empty']}
                ]
            },
            
            {
                label: 'Hierarchy', icon: 'pi pi-fw pi-align-left',
                items: [
                    {
                        label: 'Submenu 1', icon: 'pi pi-fw pi-align-left',
                        items: [
                            {
                                label: 'Submenu 1.1', icon: 'pi pi-fw pi-align-left',
                                items: [
                                    {label: 'Submenu 1.1.1', icon: 'pi pi-fw pi-align-left'},
                                    {label: 'Submenu 1.1.2', icon: 'pi pi-fw pi-align-left'},
                                    {label: 'Submenu 1.1.3', icon: 'pi pi-fw pi-align-left'},
                                ]
                            },
                            {
                                label: 'Submenu 1.2', icon: 'pi pi-fw pi-align-left',
                                items: [
                                    {label: 'Submenu 1.2.1', icon: 'pi pi-fw pi-align-left'}
                                ]
                            },
                        ]
                    },
                    {
                        label: 'Submenu 2', icon: 'pi pi-fw pi-align-left',
                        items: [
                            {
                                label: 'Submenu 2.1', icon: 'pi pi-fw pi-align-left',
                                items: [
                                    {label: 'Submenu 2.1.1', icon: 'pi pi-fw pi-align-left'},
                                    {label: 'Submenu 2.1.2', icon: 'pi pi-fw pi-align-left'},
                                ]
                            },
                            {
                                label: 'Submenu 2.2', icon: 'pi pi-fw pi-align-left',
                                items: [
                                    {label: 'Submenu 2.2.1', icon: 'pi pi-fw pi-align-left'},
                                ]
                            },
                        ]
                    }
                ]
            },
            
            {
                label: 'Start', icon: 'pi pi-fw pi-download',
                items: [
                    {
                        label: 'Buy Now', icon: 'pi pi-fw pi-shopping-cart', url: ['https://www.primefaces.org/store']
                    },
                    {
                        label: 'Documentation', icon: 'pi pi-fw pi-info-circle', routerLink: ['/documentation']
                    }
                ]
            }
            */
        ];
    }

    /**
     * The function initializes form groups for configuration and data, and updates the configuration form
     * with query parameters from the route.
     */
    async initConfigs() {
        this.userPreferences = await this.userPreferencesService.getSantovTovpilCookie() || null;
        this.userToken = this.userPreferences.tokenProfile ?? null;
        console.debug('USER TOKEN ACTUAL : ', this.userToken);

        // SE ESTABLECE PREFERENCIAS DE USUARIO
        if (this.userPreferences) {
            //   console.debug("MAIN() Preferencias de usuario actual : " + JSON.stringify(this.userPreferences, null, 2));
        }
    }

    /**
     * The function `getTranslatedLabels` is an asynchronous function that retrieves translated labels from
     * a translation service and sets them in the `translations` variable, and then calls another function
     * `getLanguages`.
     */
    async getTranslatedLabels() {
        try {
            const language = this.userPreferences?.preferences?.language ?? "es";
            const region = this.userPreferences?.preferences?.region;
            await this.translationService.getTranslatedLabels(language, region);
            return this.translationService.getLabels();
        } catch (error) {
            console.error("An error occurred while getting translated labels:", error);
            // Error al traer labels traducidos
        }
    }
}
